import {
  construirContenidoPedido,
  stylesListaEmpaquetado,
} from "./listaEmpaquetadoPdf";

export const construirContenidoLote = async (empresa, secciones, onProgress) => {
  const contenido = [];
  for (let i = 0; i < secciones.length; i++) {
    const seccion = secciones[i];
    contenido.push(
      ...construirContenidoPedido({
        empresa,
        venta: { serieNumero: seccion.serieNumero, clienteOnline: seccion.clienteOnline },
        insumos: seccion.insumos,
        origenLabel: seccion.origenLabel,
      }),
    );
    if (i < secciones.length - 1) {
      contenido.push({ text: "", pageBreak: "after" });
    }
    if (onProgress) onProgress(i + 1, secciones.length);
    if (i % 5 === 4) {
      await new Promise((resolve) => setTimeout(resolve, 0));
    }
  }
  return contenido;
};

const construirDocumentoLote = async ({ empresa = {}, secciones = [], onProgress }) => ({
  pageSize: "LETTER",
  pageMargins: [30, 35, 30, 40],
  info: {
    title: "Lista de empaquetado - Lote",
    author: empresa?.nombre || "ERP",
  },
  content: await construirContenidoLote(empresa, secciones, onProgress),
  images: {
    logo: empresa?.logo?.base64Completa,
  },
  footer: (currentPage, pageCount) => ({
    columns: [
      {
        text: "Lista de empaquetado — Lote",
        alignment: "left",
        fontSize: 8,
        color: "#888",
        margin: [30, 0, 0, 0],
      },
      {
        text: `Página ${currentPage} de ${pageCount}`,
        alignment: "right",
        fontSize: 8,
        color: "#888",
        margin: [0, 0, 30, 0],
      },
    ],
  }),
  defaultStyle: { fontSize: 9 },
  styles: stylesListaEmpaquetado,
});

export default construirDocumentoLote;
